// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* overrides for plyr-react/dist/plyr.css */
.plyr   {
    min-width: 0px;
}

:root {
    --plyr-control-icon-size: 1.25em;       /*20px*/
    --plyr-control-spacing: 0.3125em;       /*5px*/
    --plyr-font-size-time: 0.875em;         /*14px*/
    --plyr-font-size-small: 0.875em;        /*14px*/
    --plyr-range-track-height: 0.5em;       /*8px*/
    --plyr-range-thumb-height: 1em;
    --plyr-tooltip-radius: 0.1875em;       /*3px*/
}

button.plyr__control.plyr__control--overlaid    {
    padding: 0.625em;                       /*10px*/
    opacity: 1;
    border: 0.25em #fff solid;
}

.plyr--video .plyr__controls {
    padding: 0 0.3125em;
}

.fullscreen .plyr--video .plyr__controls {
    padding: 0.3125em;              /*5px*/
}

.plyr__control.plyr__control--overlaid svg {
    left: 0.125em;                  /*2px*/
}

.plyr__controls button {
    padding: 0.4374em;              /*7px*/
    border-radius: 0.1875em;        /*3px*/
}

.plyr__controls button svg {
    width: 1.25em;                 /*20px*/
    height: 1.25em;                /*20px*/
}

@media (min-width: 480px) {

    :root {
        --plyr-control-spacing: 0.625em;        /*10px*/
    }

    .plyr__controls
    .plyr__progress,
    .plyr__controls
    .plyr__time,
    .plyr__controls>button {
        margin-left:  0.625em;        /*10px*/
    }
}

.plyr--playing .plyr__controls [data-plyr=play], .plyr__controls [data-plyr=pause] {
    display: block;
}

.plyr--video .plyr__controls button.tab-focus:focus, .plyr--video .plyr__controls button:hover {
    background: 0 0;
    color: #fff;
}

@media (hover: hover) and (pointer: fine) {
    .plyr--video .plyr__controls button.tab-focus:focus, .plyr--video .plyr__controls button:hover {
        background: 0 0;
        color: #fff;
    }
}

.plyr .plyr__progress {
    display: block;
}`, "",{"version":3,"sources":["webpack://./app/styles/plyr-react.css"],"names":[],"mappings":";AACA,2CAA2C;AAC3C;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC,QAAQ,OAAO;IAC/C,gCAAgC,QAAQ,MAAM;IAC9C,8BAA8B,UAAU,OAAO;IAC/C,+BAA+B,SAAS,OAAO;IAC/C,gCAAgC,QAAQ,MAAM;IAC9C,8BAA8B;IAC9B,+BAA+B,QAAQ,MAAM;AACjD;;AAEA;IACI,gBAAgB,wBAAwB,OAAO;IAC/C,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB,eAAe,MAAM;AAC1C;;AAEA;IACI,aAAa,mBAAmB,MAAM;AAC1C;;AAEA;IACI,iBAAiB,eAAe,MAAM;IACtC,uBAAuB,SAAS,MAAM;AAC1C;;AAEA;IACI,aAAa,kBAAkB,OAAO;IACtC,cAAc,iBAAiB,OAAO;AAC1C;;AAEA;;IAEI;QACI,+BAA+B,SAAS,OAAO;IACnD;;IAEA;;;;;QAKI,qBAAqB,SAAS,OAAO;IACzC;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI,cAAc;AAClB","sourcesContent":["\n/* overrides for plyr-react/dist/plyr.css */\n.plyr   {\n    min-width: 0px;\n}\n\n:root {\n    --plyr-control-icon-size: 1.25em;       /*20px*/\n    --plyr-control-spacing: 0.3125em;       /*5px*/\n    --plyr-font-size-time: 0.875em;         /*14px*/\n    --plyr-font-size-small: 0.875em;        /*14px*/\n    --plyr-range-track-height: 0.5em;       /*8px*/\n    --plyr-range-thumb-height: 1em;\n    --plyr-tooltip-radius: 0.1875em;       /*3px*/\n}\n\nbutton.plyr__control.plyr__control--overlaid    {\n    padding: 0.625em;                       /*10px*/\n    opacity: 1;\n    border: 0.25em #fff solid;\n}\n\n.plyr--video .plyr__controls {\n    padding: 0 0.3125em;\n}\n\n.fullscreen .plyr--video .plyr__controls {\n    padding: 0.3125em;              /*5px*/\n}\n\n.plyr__control.plyr__control--overlaid svg {\n    left: 0.125em;                  /*2px*/\n}\n\n.plyr__controls button {\n    padding: 0.4374em;              /*7px*/\n    border-radius: 0.1875em;        /*3px*/\n}\n\n.plyr__controls button svg {\n    width: 1.25em;                 /*20px*/\n    height: 1.25em;                /*20px*/\n}\n\n@media (min-width: 480px) {\n\n    :root {\n        --plyr-control-spacing: 0.625em;        /*10px*/\n    }\n\n    .plyr__controls\n    .plyr__progress,\n    .plyr__controls\n    .plyr__time,\n    .plyr__controls>button {\n        margin-left:  0.625em;        /*10px*/\n    }\n}\n\n.plyr--playing .plyr__controls [data-plyr=play], .plyr__controls [data-plyr=pause] {\n    display: block;\n}\n\n.plyr--video .plyr__controls button.tab-focus:focus, .plyr--video .plyr__controls button:hover {\n    background: 0 0;\n    color: #fff;\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .plyr--video .plyr__controls button.tab-focus:focus, .plyr--video .plyr__controls button:hover {\n        background: 0 0;\n        color: #fff;\n    }\n}\n\n.plyr .plyr__progress {\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
